/* unplugin-vue-components disabled */import { render } from "./Advantage.vue?vue&type=template&id=27ca5b35&scoped=true"
import script from "./Advantage.vue?vue&type=script&lang=js"
export * from "./Advantage.vue?vue&type=script&lang=js"

import "./Advantage.vue?vue&type=style&index=0&id=27ca5b35&scoped=true&lang=css"

import exportComponent from "E:\\projects\\git\\company\\www_dixiang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ca5b35"]])

export default __exports__